<template>
	<div class="mainView">
		<headerView class="header" currentMenu='home'></headerView>
		<div class="header-bg-div"></div>
		<div class="title">{{ libraryTitle }}</div>
		<div class="search-div">
			<div class="search-item-list">
				<div class="search-item" v-for="(item, index) of searchItemList" :key="index" :class="[currentSearchItem.key===item.key ? 'active' : '']" @click="setCurrentSearchItem(item)">{{item.label}}</div>
			</div>
			<div class="search-input-view">
				<el-input v-model="searchValue" class="search-input">
					<i slot="suffix" class="el-icon-search search-icon" @click="search"></i>
					<!-- <el-button slot="suffix" icon="el-icon-search" @click="search"></el-button> -->
				</el-input>
				<div class="advanced-search" @click="openAdvancedSearch">高级搜索</div>
			</div>
		</div>
		<dataBtnList></dataBtnList>
		<div class="book-chart-div">
			<bookStatistics></bookStatistics>
		</div>
		<div class="type-word-cloud-view">
			<ChineseLibClassify></ChineseLibClassify>
			<wordCloud></wordCloud>
		</div>
		<!-- <div class="book-chart-div">
			<paperStatistics></paperStatistics>
		</div> -->
		<advancedSearch ref="advancedSearch"></advancedSearch>
	</div>
</template>

<script>
// import pdf from 'vue-pdf'

import headerView from '@/components/main/headerView.vue'
import dataBtnList from './dataBtnList'
import bookStatistics from './bookStatistics'
import advancedSearch from './advancedSearch'
import wordCloud from './wordCloud'
import ChineseLibClassify from './ChineseLibClassify'
// import paperStatistics from './paperStatistics'

// import Compressor from 'compressorjs'

export default {
	name: 'appCommonPdf',
	props: {
		pdfUrl: {
		type: String,
			default: ''
		}
	},
	components: {
		// pdf
		headerView,
		dataBtnList,
		bookStatistics,
		advancedSearch,
		wordCloud,
		ChineseLibClassify
		// paperStatistics
	},
	data () {
		return {
			searchItemList: [
				{
					label: '全部',
					key: 'all'
				},
				{
					label: '元数据',
					key: 'schema'
				},
				{
					label: '图片',
					key: 'pic'
				},
				{
					label: '人物',
					key: 'person'
				},
				{
					label: '机构',
					key: 'org'
				},
				{
					label: '地理',
					key: 'geo'
				},
				{
					label: '事件',
					key: 'event'
				},
				{
					label: '专题',
					key: 'topic'
				}
			],
			currentSearchItem: {
				key: 'all'
			},
			searchValue: '',
			libraryTitle: this.global.getLibraryInfos().libraryTitle
		}
	},
	mounted () {
		console.log($('#imgDiv'));
	},
	methods: {
		setCurrentSearchItem (item) {
			this.currentSearchItem = item;
		},
		search () {
			// console.log('当前搜索', this.searchValue);
			let routeUrl = this.$router.resolve({
                name: 'searchList',
				query: {
					schemaType: this.currentSearchItem.key,
					keyWord: this.searchValue
				}
            })
            window.open(routeUrl.href, '_blank')
		},
		openAdvancedSearch () {
			this.$refs.advancedSearch.open();
		}
	}
}
</script>

<style lang='less' scoped>
@import "~@/styles/variables.less";
.mainView {
	width: 100%;
	height: 100%;
	padding-bottom: 20px;

	.header {
		width: 100%;
		height: 80 * @uh;
		z-index: 10;
		background: rgba(248, 248, 248, 0.7);
		position: relative;
		color: #8d5e1a;
	}

	.header-bg-div {
		position: absolute;
		left: 0px;
		top: 0px;
		width: 1910 * @uw;
		height: 480 * @uh;
		background-image: url('~@/assets/images/main/header.jpg');
    	background-size: 100% 130%;
		z-index: 0;
	}

	.title {
		width: 520 * @uw;
		height: 40 * @uh;
		font-size: 40 * @uw;
		margin-left: 700 * @uw;
		position: relative;
		margin-top: 80 * @uh;
		color: #430a00;
		display: flex;
		justify-content: center;
	}

	.search-div {
		width: 780 * @uw;
		margin-top: 50 * @uh;
		margin-left: 600 * @uw;
		z-index: 1;

		.search-item-list {
			width: 100%;
			display: flex;
			justify-content: space-between;
			color: black;
			z-index: 1;
			padding: 0px 140 * @uw 0 * @uh 10 * @uw;

			.search-item {
				z-index: 1;
				cursor: pointer;
				padding: 8*@uh 16*@uw 8*@uh 16*@uw;
				border-radius: 5px;
				&.active {
					background: rgb(141,94,26);
					color: white;
				}
			}
		}

		.search-input-view {
			display: flex;
			justify-content: space-between;
			align-items: center;
			.search-input {
				border: 1px solid rgb(126, 161, 172);
            	border-radius: 5px;
			}
			.advanced-search {
				width: 100 * @uw;
				height: 45*@uh;
				z-index: 100;
				margin-left: 20 * @uw;
				background: rgb(141,94,26);
				display: flex;
				justify-content: center;
				align-items: center;
				color: white;
				cursor: pointer;
				font-size: 14px;
				font-weight: normal;
				border-radius: 5px;
			}
		}
	}

	.book-chart-div {
		width: 1200 * @uw;
		height: 482 * @uh;
		margin-top: 60 * @uh;
		margin-left: 360 * @uw;
		box-shadow: 0px 0px 10px 5px #e0e0e0;
	}
	.type-word-cloud-view {
		width: 1200 * @uw;
		height: auto;
		margin-top: 60 * @uh;
		margin-left: 360 * @uw;
		padding-bottom: 60 * @uh;
		display: flex;
		justify-content: space-between;
	}
}
/deep/ .el-input__suffix {
	display: flex;
	align-items: center;
	margin-right: -5px;
	border-radius: 5px;
	padding: 0px 20px 0px 20px;
	background: rgb(141,94,26);
}
.search-icon {
	font-size: 20 *@uw;
	cursor: pointer;
	color: white;
}
</style>
